import React from 'react';
export default function LoadingIndicator({height}) {
    return (
        <div className={'loading'} style={{height}}>
        </div>
    )
}